import React from 'react';

function Trabajos() {
  return <div>hola, soy un trabajo!</div>;
}

export default Trabajos;
